export const availableA2HChrome = value => dispatch => dispatch({ type: 'AVAILABLE_A2H_CHROME', value });
export const availableA2HChat = value => dispatch => dispatch({ type: 'AVAILABLE_A2H_CHAT', value });
export const availableA2HAd = value => dispatch => dispatch({ type: 'AVAILABLE_A2H_AD', value });
export const isFirstMessageSend = value => dispatch => dispatch({ type: 'IS_FIRST_MESSAGE_SEND', value });
export const isFirstAd = value => dispatch => dispatch({ type: 'IS_FIRST_AD', value });
export const promptOrigin = value => dispatch => dispatch({ type: 'PROMPT_ORIGIN', value });

